// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2mX9Q","row":"ProcedureTreatmentSummary_row__3Idpk"};